import { all, put } from 'redux-saga/effects';
import {
    fetchDisabledRulesSuccess,
    fetchEnabledRulesSuccess,
    fetchRules,
    fetchRulesFail,
    fetchRulesSuccess,
    updateRuleFail,
    updateRuleSuccess
} from './actions';
import {
    getRulesByCategory,
    updateRule,
    updateRuleStatus
} from './rules.backend';
import {
    makeChangeErrorPayload,
    makeErrorPayload
} from '../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../shared/toast/redux/actions';

export function* fetchRulesSaga(action) {
    try {
        const [enabledResponse, disabledResponse] = yield all([
            getRulesByCategory({ ...action.payload, enabled: true }),
            getRulesByCategory({ ...action.payload, enabled: false })
        ]);

        yield put(fetchEnabledRulesSuccess(enabledResponse.data));
        yield put(fetchDisabledRulesSuccess(disabledResponse.data));
        yield put(fetchRulesSuccess());
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchRulesFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* updateRuleSaga(action) {
    const { ruleId, ruleConfig, jurisdictionCode } = action.payload;
    try {
        const response = yield updateRule(ruleId, ruleConfig);

        yield put(updateRuleSuccess(response.data));
        yield put(
            fetchRules({
                ruleCategory: response.data.ruleCategory,
                jurisdiction: jurisdictionCode
            })
        );
    } catch (error) {
        const formattedError = makeChangeErrorPayload(error);

        yield put(updateRuleFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* updateRuleStatusSaga(action) {
    const { ruleId, enabled, jurisdictionCode } = action.payload;
    try {
        const response = yield updateRuleStatus(ruleId, enabled);

        yield put(updateRuleSuccess(response.data));
        yield put(
            fetchRules({
                ruleCategory: response.data.ruleCategory,
                jurisdiction: jurisdictionCode
            })
        );
    } catch (error) {
        const formattedError = makeChangeErrorPayload(error);

        yield put(updateRuleFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
